import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isEmpty, SpecType, SubType, InfoText, ValidationManager, fireStatusUpdate, sendRioEvent, Namespace, StatusTypes, Component, SharedCommandNames, UserAddressCommandNames } from '@chegg/commerce-utils';
import { updatedZipcode, updatedCountry, setCityFlags, setDefaultCountry } from '../UserAddressState/UserAddressState.slice';
import { saveConfigs } from '../ConfigState/ConfigState.slice';
import { authorize } from '../../api';
import { fireCallbackLoggingEvent } from '../../utils/CallbackUtil';
import { ERRORS, InlineError } from '../../constants/Errors';
export var resetFieldsCommand = function resetFieldsCommand(state, dispatch, _) {
  var _state$config$localiz;
  dispatch(updatedZipcode({
    value: '',
    error: ''
  }));
  dispatch(setDefaultCountry({
    defaultCountryCode: state.config.defaultCountryCode,
    localizedCountryList: (_state$config$localiz = state.config.localizedCountryField) === null || _state$config$localiz === void 0 ? void 0 : _state$config$localiz.value
  }));
};
export var verifyAddressCommand = function verifyAddressCommand(state, dispatch, _) {
  var _state$userAddress = state.userAddress,
    zip = _state$userAddress.zip,
    cityFlags = _state$userAddress.cityFlags,
    country = _state$userAddress.country;
  var zipError = zip.isMandatory ? ValidationManager.validateField({
    fieldName: 'zip',
    value: zip.value,
    validations: ValidationManager.fieldValidationMap['zip']
  }).error : '';
  var cityError = cityFlags.error;
  var hasCountryInlineError = country.countryCode === '';
  if (zipError) {
    dispatch(updatedZipcode({
      value: zip.value || '',
      error: zipError,
      invalid: zip.invalid,
      focused: false
    }));
    sendRioEvent({
      info: InfoText.ZIP_ERROR,
      message_detail: zip.invalid ? InlineError.INVALID : InlineError.REQUIRED,
      specType: SpecType.NOTIFICATION,
      subType: SubType.ERROR,
      callback: function callback(logObj) {
        return fireCallbackLoggingEvent(logObj);
      },
      namespace: state.config.rioNamespace
    });
  }
  if (cityError) {
    dispatch(setCityFlags({
      error: true
    }));
  }
  if (hasCountryInlineError) {
    dispatch(updatedCountry(_objectSpread(_objectSpread({}, country), {}, {
      error: true
    })));
  }
  if (zipError || zip.invalid || cityError || hasCountryInlineError) {
    fireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: UserAddressCommandNames.VERIFY_ADDRESS,
      payload: {
        component: Component.EXECUTE_COMMAND_LOGIC,
        errors: [ERRORS.INLINE_ERRORS]
      }
    }], Namespace.USER_ADDRESS);
  }
};
export var reauthorizeCommand = function reauthorizeCommand(_, dispatch, command) {
  if (!command.data || isEmpty(command.data)) return;
  var data = command.data;
  var status = authorize(data);
  if (!status.success) {
    fireStatusUpdate([{
      status: StatusTypes.ERROR,
      command: SharedCommandNames.REAUTHORIZE,
      payload: {
        component: Component.EXECUTE_COMMAND_LOGIC,
        errors: status.errors
      }
    }], Namespace.USER_ADDRESS);
  }
  dispatch(saveConfigs({
    authorization: data
  }));
};
export var saveConfigsCommand = function saveConfigsCommand(state, dispatch, command) {
  dispatch(saveConfigs(command.data));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/CommandState/CommandState.helpers.js
// module id = 4425
// module chunks = 11